import { render, staticRenderFns } from "./support_view.vue?vue&type=template&id=797b5038&"
import script from "./support_view.vue?vue&type=script&lang=js&"
export * from "./support_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports